import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UrlService } from '@uirouter/angular';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AprimaTranslateLoader extends TranslateLoader {
  private innerLoader: TranslateHttpLoader | undefined;

  constructor(
    private httpClient: HttpClient,
    private urlService: UrlService,
  ) {
    super();
  }

  bootstrap() {
    let baseHref = this.urlService.config.baseHref();
    if (!baseHref) {
      baseHref = window.location.href.substring(0, window.location.href.length - window.location.hash.length);
    }
    const baseUrl = baseHref.substring(0, baseHref.lastIndexOf('/'));
    const prefix = `${baseUrl}/assets/i18n/`;
    this.innerLoader = new TranslateHttpLoader(this.httpClient, prefix);
  }

  getTranslation(lang: string): Observable<any> {
    if (!this.innerLoader) {
      throw new Error('AprimaTranslateLoader not initialized');
    }

    return this.innerLoader.getTranslation(lang);
  }
}
